export default function Stats() {
    return (
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-project-diagram"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-2">120+</h3>
              <p className="text-gray-600">Projects Completed</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-2">70+</h3>
              <p className="text-gray-600">Satisfied Clients</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-blue-600 text-4xl mb-4">
                <i className="fas fa-code-branch"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 mb-2">3+</h3>
              <p className="text-gray-600">Years Experience</p>
            </div>
          </div>
        </div>
      </section>
    );
  }